import { render, staticRenderFns } from "./HrSalaryCalcLeaveExtraDetail.vue?vue&type=template&id=48f2b359&scoped=true&"
import script from "./HrSalaryCalcLeaveExtraDetail.vue?vue&type=script&lang=js&"
export * from "./HrSalaryCalcLeaveExtraDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryCalcLeaveExtraDetail.vue?vue&type=style&index=0&id=48f2b359&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f2b359",
  null
  
)

export default component.exports